module.exports = __webpack_public_path__ + "assets/fix-to-top.87a58c79.svg";